import { createContext } from '../utils'

export interface ButtonGroupContextValue {
  disabled?: boolean
  size?: string
  variant?: string
}

const [ButtonGroupProvider, useButtonGroupContext] = createContext<ButtonGroupContextValue>({ isOptional: true })

export { ButtonGroupProvider, useButtonGroupContext }
